import React from 'react'
import { CircularProgress } from '@mui/material'
import { useOutletContext } from 'react-router-dom'
import SyncShopifyBillingSubscription from './SyncShopifyBillingSubscription'

function Billing() {
  const { partner, listing } = useOutletContext()

  // On a hard load/refresh the parent has not fetched partner/listing yet.
  if (!partner || !listing) {
    return <CircularProgress size={20} color="primary" role="progressbar" />
  }

  return (
    <SyncShopifyBillingSubscription partner={partner} listing={listing} />
  )
}

export default Billing
